module.exports = __webpack_public_path__ + "img/content-title.e6f75397.png";